export const GET_TASK = 'GET_TASK';
export const POST_ANSWER = 'POST_ANSWER';
export const GET_ANSWER_INFO = 'GET_ANSWER_INFO';
export const GET_TASKS = 'GET_TASKS';
export const GET_SINGLE_TASK = 'GET_SINGLE_TASK';
